import * as React from 'react';

import { StatusPill } from '@coursera/coursera-ui';

import type { Skill } from 'bundles/browse/components/Domain/types/Domain';
import { capitalizeSkillName } from 'bundles/browse/components/Domain/utils/DomainUtils';
import { TrackedA } from 'bundles/page/components/TrackedLink2';

import 'css!./__styles__/DomainTopSkillPill';

type DomainSkillPillProps = Skill & {
  textColor?: string;
};
const DomainTopSkillPill = ({ skillName, numberOfTaggedCourses, skillSearchUrl, textColor }: DomainSkillPillProps) => {
  const taggedCourses = numberOfTaggedCourses ? ` (${numberOfTaggedCourses})` : '';
  return (
    <StatusPill
      size="lg"
      type="outline"
      label={`${capitalizeSkillName(skillName)}${taggedCourses}`}
      tag={(props: {}) => <TrackedA href={skillSearchUrl} trackingName="top_domain_skill" {...props} />}
      rootClassName="rc-DomainTopSkillPill"
      style={{ color: textColor || 'initial' }}
    />
  );
};

export default DomainTopSkillPill;
